<div class="mobile-home row">
  <div class="home-background p-0">
    <div class="search-mobile container container-home">
      <input *ngIf="networkStatus === 1" [ngClass]="{'placeholder-wave': placeholder}" readonly type="text"
        (click)="openOffCanvas(searchContent)" [formControl]="queryField" [style.border-radius]="'6px'"
        id="mobile-search" autocomplete="off" placeholder="{{'HOME.SEARCH.PLACEHOLDER.TEXT' | translate}}" />
      <input *ngIf="networkStatus === 0" readonly [formControl]="queryField" id="mobile-search"
        (click)="openOffCanvas(searchContent)" autocomplete="off"
        [placeholder]="'HOME.SEARCH.PLACEHOLDER.OFFLINE.TEXT' | translate" autofocus />
      <button *ngIf="networkStatus === 1" class="icon-filter-search button-none"
        (click)="openOffCanvas(advancedSearchContent)">
        <ion-icon src="assets/new-icons/options-outline.svg"></ion-icon>
      </button>
      <button *ngIf="networkStatus === 0" class="icon-filter-search button-none">
        <ion-icon src="assets/new-icons/cloud-offline-outline.svg"></ion-icon>
      </button>
      <button (click)="openOffCanvas(searchContent)" class="icon-search button-none">
        <ion-icon src="assets/new-icons/search-outline.svg"></ion-icon>
      </button>
    </div>
    <div class="shape w-100">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
    <app-mobile-popular-properties style="padding-right: 0;" [highlightsProperties]="highlightsProperties">
    </app-mobile-popular-properties>
    <app-mobile-popular-cities *ngIf="popularCities" [popularCities]="popularCities">
    </app-mobile-popular-cities>
    <section *ngIf="homeTexts" class="how-it-works bg-white pt-4 rec-pro">
      <div class="container-fluid">
        <div class="sec-title">
          <h2 [innerHTML]="'icons-home.imoalvesangola.pre.title' | translate"></h2>
          <p>{{'icons-home.imoalvesangola.pre.subtitle' | translate}}</p>
        </div>
        <div class="row service-1">
          <article class="col-lg-3 col-md-6 col-xs-12 serv" data-aos="fade-up" data-aos-delay="150">
            <div class="serv-flex">
              <div class="art-1 img-13">
                <svg xmlns="http://www.w3.org/2000/svg" width="90" viewBox="0 0 498 496">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: var(--main-color);
                      }
                    </style>
                  </defs>
                  <title>icon-4</title>
                  <g id="Capa_2" data-name="Capa 2">
                    <g id="Capa_1-2" data-name="Capa 1">
                      <g id="Layer_5" data-name="Layer 5">
                        <path class="cls-1" d="M48,448h96V368H48Zm16-64h64v48H64Z" />
                        <path class="cls-1" d="M176,368v80h96V368Zm80,64H192V384h64Z" />
                        <path class="cls-1"
                          d="M112,168V88A24,24,0,0,0,88,64H72A24,24,0,0,0,48,88v80a24,24,0,0,0,24,24H88A24,24,0,0,0,112,168Zm-48,0V88a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H72A8,8,0,0,1,64,168Z" />
                        <path class="cls-1"
                          d="M399.21,197.44a24.63,24.63,0,0,0-30.4,0L355.87,208H223.32a56.44,56.44,0,0,0,.68-8V168H324.28L340,144.42,355.72,168h16.56L388,144.42,403.72,168h16.56L436,144.42,451.72,168H468l30-40L468,88H224V56A56.07,56.07,0,0,0,168,0H56A56.07,56.07,0,0,0,0,56V200a55.87,55.87,0,0,0,32.13,50.45L0,276.16V336H16V496H480V310.48a23.8,23.8,0,0,0,7.18-41.07ZM379,209.79a8.2,8.2,0,0,1,10.12,0l88,72a8,8,0,0,1,1.14,11.26h0A8.22,8.22,0,0,1,467,294.2l-83-67.86-82.91,67.84a8.24,8.24,0,0,1-11.29-1.13,8,8,0,0,1,1.14-11.24Zm-98.2,59.64a24,24,0,0,0-3.38,33.75A22.9,22.9,0,0,0,288,310.33V320H16V288H256V272H30.81l60-48H336.32ZM304,152H224V136h72a8,8,0,0,1,8,8Zm156-48,18,24-17.85,23.81L444.28,128H427.72L412,151.58,396.28,128H379.72L364,151.58,348.28,128H331.72L320,145.58V144a24,24,0,0,0-24-24H224V104ZM16,200V56A40,40,0,0,1,56,16H168a40,40,0,0,1,40,40V200a39.14,39.14,0,0,1-.89,8H85.19L46.71,238.78A39.87,39.87,0,0,1,16,200ZM32,336H288V480H32ZM432,480H416V384H352v96H336V400a48,48,0,0,1,96,0Zm-32,0H368V400h32Zm48,0V400a64,64,0,0,0-128,0v80H304V310.4a22.48,22.48,0,0,0,7.18-3.82L384,247l72.82,59.57a24.47,24.47,0,0,0,7.18,4V480Z" />
                      </g>
                    </g>
                  </g>
                </svg>
                <h3>{{'icons-home.imoalvesangola.one.title' | translate}}</h3>
              </div>
              <div class="service-text-p">
                <p class="text-center">{{'icons-home.imoalvesangola.one.subtitle' | translate}}</p>
              </div>
            </div>
          </article>
          <article class="col-lg-3 col-md-6 col-xs-12 serv" data-aos="fade-up" data-aos-delay="250">
            <div class="serv-flex">
              <div class="art-1 img-14">
                <svg xmlns="http://www.w3.org/2000/svg" width="90" viewBox="0 0 511.98 511.95">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: var(--main-color);
                      }
                    </style>
                  </defs>
                  <title>icon-5</title>
                  <g id="Capa_2" data-name="Capa 2">
                    <g id="Capa_1-2" data-name="Capa 1">
                      <g id="Layer_1" data-name="Layer 1">
                        <path class="cls-1"
                          d="M136.41,235.43a16.88,16.88,0,0,0,5,12.06l6,6a42.69,42.69,0,0,0,60.34,0L250.29,211a93.11,93.11,0,0,0,60,21.72h0a93.56,93.56,0,0,0,66.44-27.57,8.53,8.53,0,1,0-12.07-12.07,76.54,76.54,0,0,1-54.38,22.57h0A76.29,76.29,0,0,1,256,193.18a8.54,8.54,0,0,0-12.07,0l-48.28,48.27c-9.66,9.67-26.53,9.67-36.2,0l-6-6,102.61-102.6c9.57-9.57,18.65-9.57,30.17-9.57,12.32,0,27.67,0,42.24-14.56L352.6,84.58a8.53,8.53,0,1,0-12.07-12.07L316.4,96.65c-9.57,9.57-18.66,9.57-30.18,9.57-12.32,0-27.66,0-42.23,14.56L141.42,223.35A16.94,16.94,0,0,0,136.41,235.43Z" />
                        <path class="cls-1"
                          d="M76.78,93.88A17.07,17.07,0,1,0,59.72,76.8h0A17.09,17.09,0,0,0,76.78,93.88Z" />
                        <path class="cls-1"
                          d="M159.51,120.78l24.14,24.14a8.53,8.53,0,0,0,12.06-12.07l-24.13-24.13a8.53,8.53,0,1,0-12.07,12.06Z" />
                        <path class="cls-1"
                          d="M435.18,59.74a17.07,17.07,0,1,0-17.06-17.08v0A17.09,17.09,0,0,0,435.18,59.74Z" />
                        <path class="cls-1"
                          d="M454.75,181.71c-13.87,13.87-18.63,36.46-23.23,58.3-4.08,19.39-8.3,39.45-18.58,49.73L400.87,301.8A8.55,8.55,0,1,0,413,313.87l12-12.07c13.86-13.86,18.61-36.43,23.21-58.27,4.09-19.41,8.32-39.47,18.59-49.75a8.53,8.53,0,0,0-12.06-12.07h0Z" />
                        <path class="cls-1"
                          d="M509.48,181.71l-139-139,28.1-28.1a8.56,8.56,0,0,0-12.1-12.1L352.35,36.64a8.51,8.51,0,0,0,0,12l0,0L497.42,193.78a8.53,8.53,0,0,0,12.06-12.07Z" />
                        <path class="cls-1"
                          d="M316.4,253.53a8.53,8.53,0,0,0-12.07,12.07l90.51,90.51a17.07,17.07,0,0,1-24.14,24.14l-90.51-90.51a8.53,8.53,0,1,0-12.07,12.06L382.77,416.45a17.07,17.07,0,0,1-24.14,24.14L250,332a8.53,8.53,0,1,0-13,11,8,8,0,0,0,1,1l96.54,96.54a17.1,17.1,0,0,1,0,24.14,17.46,17.46,0,0,1-24.13,0l-12.08-12.06h0L219.88,374.2a8.53,8.53,0,0,0-12.06,12.06l78.43,78.44a17.06,17.06,0,0,1-24.13,24.13h0L117,343.85c-22.13-22.13-26.93-50-31.17-74.65-3.57-20.71-6.94-40.26-20-53.35a8.55,8.55,0,1,0-12.13,12.06c9.26,9.26,12,25.45,15.28,44.19,4.43,25.78,10,57.85,35.92,83.81L250,500.91a34.15,34.15,0,0,0,57.62-17.5,34.86,34.86,0,0,0,38.91-6.64,34,34,0,0,0,9.36-17.51,34.13,34.13,0,0,0,38.92-54.9l-3.24-3.24A34.13,34.13,0,0,0,406.91,344Z" />
                        <path class="cls-1"
                          d="M159.61,70.78l-51.2-51.2A8.53,8.53,0,0,0,96.35,31.64l45.17,45.17-139,139a8.53,8.53,0,1,0,12,12.1h0L159.61,82.85a8.53,8.53,0,0,0,0-12Z" />
                        <path class="cls-1"
                          d="M209.86,493.37c-4.75,2.49-12.87,2.79-20.18-4.51s-7.26-15.83-4.88-19.53a8.53,8.53,0,0,0-13.22-10.64,17.07,17.07,0,0,1-24.14-24.14,8.53,8.53,0,1,0-12.07-12.07h0l-6,6a17.06,17.06,0,0,1-24.13-24.13h0l6-6A8.54,8.54,0,0,0,101,384.92c-4.64,2.68-12.81,2.37-19.86-4.67-7.49-7.49-7.45-15.8-5-19.3a8.53,8.53,0,0,0-13.39-10.57,6.58,6.58,0,0,0-.61.88c-6.91,10-6.72,27.32,7,41.05a38,38,0,0,0,17.1,10.18,34.15,34.15,0,0,0,39.41,47.08,34.1,34.1,0,0,0,36.89,31.05,36.24,36.24,0,0,0,4.14-.61,37.55,37.55,0,0,0,11,20.94c7.89,7.88,17.11,11,25.52,11a32,32,0,0,0,14.65-3.49,8.53,8.53,0,0,0-7.92-15.11Z" />
                      </g>
                    </g>
                  </g>
                </svg>
                <h3>{{'icons-home.imoalvesangola.two.title' | translate}}</h3>
              </div>
              <div class="service-text-p">
                <p class="text-center">{{'icons-home.imoalvesangola.two.subtitle' | translate}}</p>
              </div>
            </div>
          </article>
          <article class="col-lg-3 col-md-6 col-xs-12 serv mb-0 pt" data-aos="fade-up" data-aos-delay="350">
            <div class="serv-flex arrow">
              <div class="art-1 img-15">
                <svg xmlns="http://www.w3.org/2000/svg" width="90" viewBox="0 0 512 496.82">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: var(--main-color);
                      }
                    </style>
                  </defs>
                  <title>icon-6</title>
                  <g id="Capa_2" data-name="Capa 2">
                    <g id="Capa_1-2" data-name="Capa 1">
                      <g id="Layer_1" data-name="Layer 1">
                        <path class="cls-1"
                          d="M483.38,257.74H483V106.37A11.41,11.41,0,0,0,471.6,95H411.55L366.67,6.24a11.41,11.41,0,0,0-15.33-5L166,95H46.19A46,46,0,0,0,0,139.35V450.63a46.24,46.24,0,0,0,46.19,46.19H471.6A11.42,11.42,0,0,0,483,485.41V397.56h.37A28.65,28.65,0,0,0,512,369V286.36A28.65,28.65,0,0,0,483.38,257.74Zm-23.18-140V162H445.45l-22.37-44.2Zm-286.37-1.23h0l177.63-89.8,42.89,84.8h0L419.89,162H397.78a9.21,9.21,0,0,0-.5-1.16l-29.35-58a11.4,11.4,0,0,0-12.33-6.06l-3.49.67a33,33,0,0,1-34.23-15.11l-2.28-3.71a11.38,11.38,0,0,0-14.87-4.21L127.49,162H84ZM372.31,162H178L302,99.33a56.09,56.09,0,0,0,49.38,21.22ZM46.19,117.78h74.68L37.08,160.16a23.62,23.62,0,0,1-13.33-15l-.06-.19c-.12-.44-.23-.89-.33-1.34s-.15-.78-.22-1.18-.1-.62-.14-.94c-.06-.55-.11-1.1-.14-1.66A23.27,23.27,0,0,1,46.19,117.78ZM460.2,474H46.2A23.42,23.42,0,0,1,22.82,450.6v-5.31H371.3a11.41,11.41,0,0,0,.68-22.81H22.81v-244a45.72,45.72,0,0,0,15,5.51h.67c.68.11,1.35.21,2,.29l.4.05h0l1,.09c.47,0,.93.1,1.41.12h.35c.89,0,1.73.07,2.55.07h414V210H108.67a11.41,11.41,0,0,0-.68,22.81H460.2v25h-165a11.39,11.39,0,0,0-11.41,11.39h0v117a11.42,11.42,0,0,0,11.41,11.4h165Zm23.18-99.26H306.62v-94.2H483.38a5.81,5.81,0,0,1,5.81,5.81V369h0a5.81,5.81,0,0,1-5.81,5.77Z" />
                        <path class="cls-1"
                          d="M363.28,284.59a43.06,43.06,0,1,0,43.06,43.06h0A43.11,43.11,0,0,0,363.28,284.59Zm0,63.31a20.25,20.25,0,1,1,20.24-20.26h0a20.27,20.27,0,0,1-20.24,20.25Z" />
                        <path class="cls-1"
                          d="M417.16,431.69a11.16,11.16,0,0,0-.65-2.13,10.9,10.9,0,0,0-1.05-2,11.71,11.71,0,0,0-1.41-1.73,11.47,11.47,0,0,0-10.3-3.11,9.36,9.36,0,0,0-2.13.65,10.68,10.68,0,0,0-2,1,11.67,11.67,0,0,0-1.74,1.41,10.25,10.25,0,0,0-1.41,1.73,10.9,10.9,0,0,0-1.05,2,11.38,11.38,0,0,0-.65,6.59,12.18,12.18,0,0,0,.65,2.13,10.9,10.9,0,0,0,1.05,2,11.67,11.67,0,0,0,1.41,1.74,14,14,0,0,0,1.74,1.42,12.28,12.28,0,0,0,2,1.05,11.36,11.36,0,0,0,8.72,0,12.28,12.28,0,0,0,2-1.05,13.15,13.15,0,0,0,1.74-1.42,11.67,11.67,0,0,0,1.41-1.74,10.9,10.9,0,0,0,1.05-2,12.18,12.18,0,0,0,.65-2.13,11.28,11.28,0,0,0,.23-2.24A10.55,10.55,0,0,0,417.16,431.69Z" />
                        <path class="cls-1"
                          d="M85.18,219.16a11.92,11.92,0,0,0-.65-2.13,12,12,0,0,0-1-2,11.84,11.84,0,0,0-1.43-1.73,9.36,9.36,0,0,0-1.73-1.41,10.32,10.32,0,0,0-2-1,10.68,10.68,0,0,0-2.13-.65,11.16,11.16,0,0,0-4.46,0,9.89,9.89,0,0,0-2.13.65,11.4,11.4,0,0,0-3.74,2.46,11.46,11.46,0,0,0-2.46,12.43,10.9,10.9,0,0,0,1,2,11.71,11.71,0,0,0,1.41,1.73,11.35,11.35,0,0,0,1.74,1.42,10.9,10.9,0,0,0,2,1.05,11.19,11.19,0,0,0,6.59.65,12.18,12.18,0,0,0,2.13-.65,11.38,11.38,0,0,0,3.7-2.47,11.25,11.25,0,0,0,2.48-3.7,12.18,12.18,0,0,0,.65-2.13,12.05,12.05,0,0,0,.21-2.24A11.88,11.88,0,0,0,85.18,219.16Z" />
                      </g>
                    </g>
                  </g>
                </svg>
                <h3>{{'icons-home.imoalvesangola.three.title' | translate}}</h3>
              </div>
              <div class="service-text-p">
                <p class="text-center">{{'icons-home.imoalvesangola.three.subtitle' | translate}}</p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #searchContent let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-basic-title">{{'HOME.SEARCH.TEXT' | translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeOffCanvas(searchContent)"></button>
  </div>
  <div class="offcanvas-body mobile-home-canvas p-0">
    <form (ngSubmit)="generalSearch(searchContent)">
      <div class="search-mobile container container-home">
        <input *ngIf="networkStatus === 1" [formControl]="queryField" id="mobile-search" autocomplete="off"
          [placeholder]="'HOME.SEARCH.PLACEHOLDER.TEXT' | translate" autofocus />
        <input *ngIf="networkStatus === 0" [formControl]="queryField" id="mobile-search" [attr.disabled]="true"
          autocomplete="off" [placeholder]="'HOME.SEARCH.PLACEHOLDER.OFFLINE.TEXT' | translate" autofocus />
        <div class="row">
          <div class="search-auto-complete mt-3">
            <ul *ngIf="(queryField.value === null || queryField.value === '') && latestSearches.length > 0"
              class="search-results">
              <li class="results-number d-flex align-items-center">
                <ion-icon src="assets/new-icons/history.svg"></ion-icon><span>{{latestSearches.length}}
                  <span *ngIf="latestSearches.length === 1">{{'t-last-search' | translate}}</span>
                  <span *ngIf="latestSearches.length > 1"> {{'t-latest-searches' | translate}}</span>
                </span>
              </li>
              <li *ngFor="let result of latestSearches"
                (click)="searchWithLatest(searchContent, result.searchKey, result.type)"
                class="option-result position-relative">
                <span class="result-title">{{result?.type == 'freeSearch' ? result?.searchKey :
                  result.name}}</span>
                <br>
                <span class="result-subtitle">{{'PROPERTIES.SEARCH-RESULTS.TEXT' | translate}}:
                  {{result?.total}}</span>
                <ion-icon (click)="clearSearch = {
                                    isClear: true, result: result.searchKey
                                }" class="clear-search fs-5" src="assets/new-icons/trash-outline.svg"></ion-icon>
              </li>
            </ul>
            <ul *ngIf="searchResult.length > 0 &&  queryField.value !== ''" class="search-results">
              <li class="results-number d-flex align-items-center">
                <ion-icon src="assets/new-icons/location-outline.svg"></ion-icon>{{searchResult.length}}
                {{'t-locations' |
                translate}}
              </li>
              <li *ngFor="let result of searchResult"
                (click)="queryField.setValue(result.name); searchResult = []; searchByLocation(result.id, searchContent)"
                class="option-result"><span class="result-title">{{result.name}}</span><br><span
                  class="result-subtitle">{{result.type | translate}}</span>
              </li>
            </ul>
          </div>
        </div>
        <a class="icon-search">
          <ion-icon src="assets/new-icons/search-outline.svg"></ion-icon>
        </a>
      </div>
      <div class="text-center home-search-filter">
        <button type="button" [disabled]="networkStatus === 0" class="btn btn-outline-dark w-75"
          (click)="generalSearch(searchContent)">{{'HOME.SEARCH.TEXT' |
          translate}}</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #advancedSearchContent let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-basic-title">{{'FILTERS.ADVANCED-TITLE.TEXT' | translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeOffCanvas(advancedSearchContent)"></button>
  </div>
  <div class="offcanvas-body">
    <form>
      <div class="mb-3 row">
        <div class="explore__form-checkbox-list search-home">
          <div class="row">
            <div class="col-12 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  <ion-icon class="me-2" name="bookmark-outline"></ion-icon>{{'t-reference' |
                  translate}}
                </div>
                <input [(ngModel)]="searchForm.reference" [ngModelOptions]="{standalone: true}" type="text"
                  class="form-control" placeholder="{{'t-reference' |
                                translate}}">
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  {{'t-district' |
                  translate}}
                </div>
                <ng-select (change)="districtChange()" [searchable]="false" [(ngModel)]="selectedDistrict"
                  [ngModelOptions]="{standalone: true}" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let district of searchData.locations"
                    [value]="district.countryId + '-' + district.id + '-' + district.regionId">{{district.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  {{'t-county' |
                  translate}}
                </div>
                <ng-select (change)="countyChange()" [searchable]="false" [(ngModel)]="selectedCounty"
                  [ngModelOptions]="{standalone: true}" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let c of county" [value]="c.id">{{c.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  {{'t-parish' |
                  translate}}
                </div>
                <ng-select [(ngModel)]="selectedParish" [searchable]="false" [ngModelOptions]="{standalone: true}"
                  [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let p of parish" [value]="p.id">{{p.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2"
                    src="assets/new-icons/briefcase-outline.svg"></ion-icon>{{'FILTERS.BUSINESS.TEXT'
                  |
                  translate}}
                </div>
                <ng-select [(ngModel)]="searchForm.businessType" [searchable]="false"
                  [ngModelOptions]="{standalone: true}" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let bType of searchData.businessType" [value]="bType.id">{{bType.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2"
                    src="assets/new-icons/business-outline.svg"></ion-icon>{{'FILTERS.PROPERTY-TYPE.TEXT'
                  |
                  translate}}
                </div>
                <ng-select [(ngModel)]="searchForm.propertyType" [searchable]="false"
                  [ngModelOptions]="{standalone: true}" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let pType of searchData.propertyType" [value]="pType.id">{{pType.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  <ion-icon class="me-2"
                    src="assets/new-icons/construct-outline.svg"></ion-icon>{{'FILTERS.PROPERTY-STATE.TEXT'
                  |
                  translate}}
                </div>
                <ng-select [(ngModel)]="searchForm.propertyCondition" [searchable]="false"
                  [ngModelOptions]="{standalone: true}" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let sType of searchData.propertyCondition"
                    [value]="sType.id">{{sType.name}}</ng-option>
                </ng-select>
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0 ">
              <!-- Form Bedrooms -->
              <div class="form-group beds">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2" src="assets/new-icons/bed-outline.svg"></ion-icon>{{'FILTERS.BEDROOMS.TEXT' |
                  translate}}
                </div>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value='' class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                      aria-selected="true">{{'FILTERS.ANY.TEXT' |
                      translate}}</button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value="0" class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                      aria-selected="false">0</button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value="1" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">1</button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value="2" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">2</button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value="3" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">3</button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button value="4" class="nav-link beds-last" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">4+</button>
                  </li>
                </ul>
              </div>
              <!--/ End Form Bedrooms -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pl-0 pr-30">
              <!-- Form Bathrooms -->
              <div class="form-group bath">
                <div class="filter-title mb-2">
                  <i class="fa fa-bath me-2" aria-hidden="true"></i>{{'FILTERS.BATHROOMS.TEXT' |
                  translate}}
                </div>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='' class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                      aria-selected="true">{{'FILTERS.ANY.TEXT' |
                      translate}}</button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='0' class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                      aria-selected="false">0</button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='1' class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">1</button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='2' class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">2</button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='3' class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">3</button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button value='4' class="nav-link bath-last" id="pills-contact-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                      aria-selected="false">4+</button>
                  </li>
                </ul>
              </div>
              <!--/ End Form Bathrooms -->
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 py-1 pr-30 mr-5 sld">
              <!-- Price Fields -->
              <div class="main-search-field-2">
                <!-- Area Range -->
                <div>
                  <label><ion-icon class="me-2"
                      src="assets/new-icons/resize-outline.svg"></ion-icon>{{'FILTERS.AREA-RANGE.TEXT'
                    |
                    translate}} (m²)</label>
                  <div class="d-flex align-items-center mt-1 gap-1">
                    <input [ngModelOptions]="{standalone: true}" (change)="inputChange('area')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="areaValue">
                    <span>-</span>
                    <input [ngModelOptions]="{standalone: true}" (change)="inputChange('area')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="areaMaxValue">
                  </div>
                  <div class="clearfix"></div>
                </div>
                <br>
                <!-- Price Range -->
                <div>
                  <label><ion-icon class="me-2"
                      src="assets/new-icons/cash-outline.svg"></ion-icon>{{'FILTERS.PRICE-RANGE.TEXT'
                    |
                    translate}}</label>
                  <div class="d-flex align-items-center mt-1 gap-1">
                    <input [ngModelOptions]="{standalone: true}" (change)="inputChange('price')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="priceValue">
                    <span>-</span>
                    <input [ngModelOptions]="{standalone: true}" (change)="inputChange('price')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="priceMaxValue">
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 py-1 pr-30 mb-4">
              <!-- Checkboxes --><label><ion-icon class="me-2 mt-2"
                  name="build-outline"></ion-icon>{{'FILTERS.CHARACTERISTICS.TEXT'
                |
                translate}}</label>
              <div class="checkboxes one-in-row mt-0 margin-bottom-10 ch-1 row">
                <div *ngFor="let char of searchData.characteristics; let i = index;" class="col-6">
                  <ng-container *ngIf="i <= 5">
                    <input id="check-char-{{char.id}}" type="checkbox" name="check">
                    <label for="check-char-{{char.id}}">{{char.name}}</label>
                  </ng-container>
                </div>
                <div *ngIf="!moreChar && searchData.characteristics.length > 4" class="col-12 mt-3">
                  <div class="more-char-button align-items-center d-flex fs-6 justify-content-center">
                    <a (click)="moreChar = true"><ion-icon src="assets/new-icons/add-circle-outline.svg"
                        class="me-1"></ion-icon>{{'t-more-chars' | translate}}</a>
                  </div>
                </div>
              </div>
              <div *ngIf="moreChar && searchData.characteristics.length > 6"
                class="checkboxes one-in-row margin-bottom-10 row">
                <div *ngFor="let char of searchData.characteristics; let i = index;" class="col-6">
                  <ng-container *ngIf="i > 5">
                    <input id="check-char-{{char.id}}" type="checkbox" name="check">
                    <label for="check-char-{{char.id}}">{{char.name}}</label>
                  </ng-container>
                </div>
                <div class="col-12 mt-3">
                  <div class="more-char-button align-items-center d-flex fs-6 justify-content-center">
                    <a (click)="moreChar = false"><ion-icon src="assets/new-icons/remove-circle-outline.svg"
                        class="me-1"></ion-icon>{{'t-less-chars' | translate}}</a>
                  </div>
                </div>
              </div>
              <!-- Checkboxes / End -->
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="text-end home-filter">
      <button type="button" class="btn btn-clear me-2 d-inline-flex align-items-center float-start"
        (click)="clearFilters()"><span class="me-1">{{'FILTERS.CLEAR.TEXT' | translate}}</span> <ion-icon class="fs-5"
          src="assets/new-icons/close-outline.svg"></ion-icon></button>
      <button type="button" class="btn btn-outline-dark"
        (click)="searchWithAdvanced(advancedSearchContent)">{{'HOME.SEARCH.TEXT' | translate}}</button>
    </div>
  </div>
</ng-template>
